/**
 * This is a collection of bits. Every bit must only appear once.
 *
 * The intention is to check a field twice or even more often. This allows us to yield more precise error messages.
 *
 * E.g. if we want to yield both, "Das Feld ist erforderlich" and "Die Eingabe ist ungültig", we should give a field:
 *
 * <code>
 *      ValidationChecks.NOT_EMPTY_CHECK | ValidationChecks.CUSTOM_REGEX_CHECK
 * </code>
 *
 * If the field is empty, the first check will fail with the first messages. The regex would fail as well, but only would produce
 * "Die Eingabe ist ungültig". So in the end we need to run two checks.
 *
 */
export enum ValidationChecks {
    NOT_EMPTY_CHECK = 1 << 1,
    CUSTOM_REGEX_CHECK = 1 << 2,
    DATE_REGEX_CHECK = 1 << 3,
    DATE_FUTURE_CHECK = 1 << 4,
    SELECT_BOX_SELECTED_CHECK = 1 << 5,
    CHECK_BOX_SELECTED_CHECK = 1 << 6,
    CHECK_PERCENT = 1 << 7
}
